document.addEventListener('DOMContentLoaded', () => {
    const slideCount = document.querySelectorAll('.care-guide-swiper .swiper-slide').length;

    const careGuideSwiper = new Swiper('.care-guide-swiper', {
        loop: slideCount >= 4,
        slidesPerView: 2,
        spaceBetween: 15,
        navigation: {
            nextEl: ".js-care-guide-swiper-next",
            prevEl: ".js-care-guide-swiper-prev"
        },
        breakpoints: {
            576: {
                slidesPerView: 4,
                spaceBetween: 25,
            }
        }
    })
})
